import styled from 'styled-components';
import { AuthFormContainer } from '../elements';

export const AuthSpinContainer = styled(AuthFormContainer)`
  text-align: center;
`;
